import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'
import moment from 'moment'

export const GACHA_TAB_TYPE = {
  ticket: { key: 'ticket', label: '未使用のガチャ券' },
  prize: { key: 'prize', label: '特典獲得履歴' }
}

export const GACHA_RESULT_TYPE = {
  hit: 'hit',
  failure: 'failure',
  error: 'error'
}

export const GACHA_PRIZE_TYPE = {
  coupon: 'coupon',
  prize: 'prize',
  stamp: 'stamp'
}

const tokenError = () => {
  return {
    title: `エラー ${ErrorCode.CODE_ERROR_TOKEN}`,
    message: ErrorMessage.MSG_ERROR_TOKEN
  }
}

const apiError = (res) => {
  return {
    title: res && res.data && res.data.data && res.data.data.code ?
      `エラー ${res.data.data.code}` :
      `エラー ${ErrorCode.CODE_ERROR_NETWORK}`,
    message: res && res.data && res.data.data && res.data.data.message ?
      res.data.data.message :
      ErrorMessage.MSG_ERROR_NETWORK
  }
}

export const Gacha = {
  namespaced: true,
  state: {
    selectedTab: GACHA_TAB_TYPE.ticket,
    tickets: [],
    prizes: [],
    error: null
  },
  getters: {
    selectedTab: (state) => {
      return state.selectedTab
    },
    tickets: (state) => {
      return state.tickets.sort((a, b) => {
        return moment(b.get_at).unix() - moment(a.get_at).unix()
      })
    },
    prizes: (state) => {
      return state.prizes
    },
    error: (state) => {
      return state.error
    }
  },
  mutations: {
    updateTickets(state, tickets) {
      state.tickets = tickets
    },
    updatePrizes(state, prizes) {
      state.prizes = prizes
    },
    updateSelectedTab(state, tab) {
      state.selectedTab = tab
    },
    updateError(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchContents({ commit, state }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime

      if (!token) {
        commit('updateError', tokenError())
        return
      }

      const res = state.selectedTab.key === GACHA_TAB_TYPE.ticket.key ?
        await APIClient.postGachaList(token, accTime, userId) :
        await APIClient.postGachaPrizes(token, accTime, userId)

      if (res && res.data && res.data.data && res.data.data.code === ErrorCode.CODE_SUCCESS) {
        const mutationKey = state.selectedTab.key === GACHA_TAB_TYPE.ticket.key ? 'updateTickets' : 'updatePrizes'
        const dataKey = state.selectedTab.key === GACHA_TAB_TYPE.ticket.key ? 'gacha_histories' : 'gacha_prizes'
        commit(mutationKey, res.data.data[dataKey])
      } else {
        commit('updateError', apiError(res))
      }
    },
    async turnGacha({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      const historyId = payload.historyId

      if (!token) {
        commit('updateError', tokenError())
        return { type: GACHA_RESULT_TYPE.error, data: null }
      }

      const res = await APIClient.postGacha(token, accTime, userId, historyId)
      if (res && res.data && res.data.data && res.data.data.code === ErrorCode.CODE_SUCCESS) {
        const type = res.data.data.gacha_result.result ? GACHA_RESULT_TYPE.hit : GACHA_RESULT_TYPE.failure
        return { type, data: type === GACHA_RESULT_TYPE.hit ? res.data.data.gacha_result.detail : null }
      } else {
        commit('updateError', apiError(res))
        return { type: GACHA_RESULT_TYPE.error, data: null }
      }
    },
    async fetchNotifications({ commit, state }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime

      if (!token) {
        commit('updateError', tokenError())
        return
      }

      const res = await APIClient.postGachaNotify(token, accTime, userId)
      if (res && res.data && res.data.data && res.data.data.code === ErrorCode.CODE_SUCCESS) {
        console.log(res.data.data)
        return res.data.data.gacha_notify
      } else {
        console.log('error')
        commit('updateError', apiError(res))
        return null
      }
    },
    setSelectedTab({ commit }, tab) {
      commit('updateSelectedTab', tab)
    },
    setError({ commit }, error) {
      commit('updateError', error)
    }
  }
}
